module.exports = __webpack_public_path__ + "img/kma_gallery5.0617bd20.jpg";